import React from 'react';
import { Table, Select, Input, Tag } from 'nhsuk-react-components';

/**
 * Shared mapping grid — NHS Table + Select + Input (no antd).
 * Rows: { key, dtoProperty, contractKey?, type, entity?, csvHeader, defaultValue, required? }
 */
export default function MappingTable({
  deviceMappings,
  setDeviceMappings,
  csvHeaders,
  itemDto = {},
  requiredDtoProperties = [],
}) {
  const rowKeyOf = (record) => record.key || record.contractKey || record.dtoProperty;

  const handleCsvHeaderChange = (rowKey, csvHeader) => {
    setDeviceMappings((prev) =>
      prev.map((mapping) =>
        rowKeyOf(mapping) === rowKey ? { ...mapping, csvHeader: csvHeader || '' } : mapping
      )
    );
  };

  const handleDefaultValueChange = (rowKey, defaultValue) => {
    setDeviceMappings((prev) =>
      prev.map((mapping) =>
        rowKeyOf(mapping) === rowKey ? { ...mapping, defaultValue } : mapping
      )
    );
  };

  const isRequiredField = (record) =>
    record.required === true ||
    requiredDtoProperties.includes(record.contractKey) ||
    requiredDtoProperties.includes(record.dtoProperty) ||
    requiredDtoProperties.includes(rowKeyOf(record));

  return (
    <div style={{ maxHeight: 320, overflow: 'auto' }}>
      <Table responsive className="compact-admin-table">
        <Table.Head>
          <Table.Row>
            <Table.Cell>DTO property</Table.Cell>
            <Table.Cell>File column</Table.Cell>
            <Table.Cell>Default if empty</Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {(deviceMappings || []).map((record) => {
            const key = rowKeyOf(record);
            const required = isRequiredField(record);
            return (
              <Table.Row key={key}>
                <Table.Cell>
                  <strong>{record.dtoProperty}</strong>
                  {required && (
                    <Tag style={{ marginLeft: 8 }} color="red">
                      Required
                    </Tag>
                  )}
                  <div className="nhsuk-u-secondary-text-color" style={{ fontSize: 12 }}>
                    {record.entity ? `${record.entity} · ` : ''}
                    {record.type || itemDto?.[key] || itemDto?.[record.dtoProperty] || ''}
                    {record.contractKey && record.contractKey !== record.dtoProperty
                      ? ` · file key: ${record.contractKey}`
                      : ''}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <Select
                    id={`map-col-${key}`}
                    label=""
                    name={`map-col-${key}`}
                    value={record.csvHeader || ''}
                    onChange={(e) => handleCsvHeaderChange(key, e.target.value)}
                  >
                    <option value="">
                      {required ? 'Required — select column' : 'Optional / not mapped'}
                    </option>
                    {(csvHeaders || []).map((header, index) => (
                      <option key={`${index}-${header}`} value={String(header).trim()}>
                        {header}
                      </option>
                    ))}
                  </Select>
                </Table.Cell>
                <Table.Cell>
                  <Input
                    id={`map-default-${key}`}
                    label=""
                    name={`map-default-${key}`}
                    value={record.defaultValue || ''}
                    onChange={(e) => handleDefaultValueChange(key, e.target.value)}
                    placeholder="Optional"
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
}
